import { ErrorHandler, Injectable } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { ErrorWithResourceKey } from 'app/shared/errorWithResourceKey';
import { Level, Logger } from './shared/logger';
import { LoggerFactory } from './shared/loggerFactory';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private logger: Logger;

    constructor(private loggerFactory: LoggerFactory, private toasterService: ToasterService) {
        this.logger = loggerFactory.create('GlobalErrorHandler');
    }

    public handleError(error: ErrorWithResourceKey) {
        try {
            if (error.resourceKey) {
                this.toasterService.pop('error', undefined, error.resourceKey);
            } else {
                if (this.isWarning(error)) {
                    this.logger.warn(error.message, error.stack);
                } else {
                    this.logger.error(error.message, error.stack);
                }
            }

        } catch (ex) { }
    }

    private isWarning(error: Error) {
        return error.message === 'Uncaught (in promise): Response with status: 0  for URL: null';
    }
}



// WEBPACK FOOTER //
// ./src/app/globalErrorHandler.ts